// ไฟล์: frontend/src/pages/Login.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/auth';
import Swal from 'sweetalert2';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  
  useEffect(() => {
    // ถ้าล็อกอินแล้ว ให้ไปยังหน้าที่เหมาะสม
    if (authService.isAuthenticated()) {
      const user = authService.getCurrentUser();
      if (user.role === 'admin') {
        navigate('/admin/dashboard');
      } else {
        navigate('/teacher/dashboard');
      }
    }
  }, [navigate]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!username || !password) {
      Swal.fire({
        icon: 'warning',
        title: 'กรุณาระบุข้อมูลให้ครบถ้วน',
        text: 'โปรดกรอกชื่อผู้ใช้และรหัสผ่าน',
        confirmButtonColor: '#ff6b01'
      });
      return;
    }
    
    setIsLoading(true);
    
    try {
      const user = await authService.login(username, password);
      
      Swal.fire({
        icon: 'success',
        title: 'เข้าสู่ระบบสำเร็จ',
        text: `ยินดีต้อนรับ ${user.first_name} ${user.last_name}`,
        confirmButtonColor: '#ff6b01',
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        // นำทางไปยังหน้าที่เหมาะสมตามบทบาท
        if (user.role === 'admin') {
          navigate('/admin/dashboard');
        } else {
          navigate('/teacher/dashboard');
        }
      });
    } catch (error) {
      console.error('Login error:', error);
      
      let errorMessage = 'เกิดข้อผิดพลาดในการเข้าสู่ระบบ';
      if (error.response) {
        errorMessage = error.response.data?.message || errorMessage;
      }
      
      Swal.fire({
        icon: 'error',
        title: 'เข้าสู่ระบบไม่สำเร็จ',
        text: errorMessage,
        confirmButtonColor: '#ff6b01'
      });
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-logo text-white">
          <img 
            src="https://www.i-pic.info/i/krVq1004512.jpg" 
            alt="CMS Logo" 
            className="img-circle mr-2"
            style={{ width: '50px', height: '50px' }}
          />
          <span>CMS:2025</span>
        </div>
        
        <div className="card login-card">
          <div className="card-header bg-orange text-center">
            <h3 className="mb-0">เข้าสู่ระบบจัดการชั้นเรียน</h3>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="fas fa-user"></i>
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="ชื่อผู้ใช้"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  disabled={isLoading}
                />
              </div>
              
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="fas fa-lock"></i>
                  </span>
                </div>
                <input
                  type="password"
                  className="form-control"
                  placeholder="รหัสผ่าน"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={isLoading}
                />
              </div>
              
              <div className="row">
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn-orange btn-block"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <><i className="fas fa-spinner fa-spin mr-2"></i> กำลังเข้าสู่ระบบ...</>
                    ) : (
                      <>เข้าสู่ระบบ <i className="fas fa-sign-in-alt ml-2"></i></>
                    )}
                  </button>
                </div>
              </div>
            </form>
            
            <div className="mt-3 text-center">
              <p className="mb-1">
                <small>ชื่อผู้ใช้/รหัสผ่านเริ่มต้นสำหรับแอดมิน:</small>
              </p>
              <p className="text-muted">
                <small>admin / admin123</small>
              </p>
              <p className="mb-1">
                <small>ชื่อผู้ใช้/รหัสผ่านเริ่มต้นสำหรับครู:</small>
              </p>
              <p className="text-muted">
                <small>teacher1 / teacher123</small>
              </p>
              <p className="mb-1">
                <small>ชื่อผู้ใช้/รหัสผ่านเริ่มต้นสำหรับนักเรียน:</small>
              </p>
              <p className="text-muted">
                <small>student1 / student123</small>
              </p>
            </div>
            
          </div>
        </div>
        
        <div className="text-center mt-3 text-white">
          <small>
            พัฒนาโดย Devtaiban - <a href="http://www.Kruwirat.com" target="_blank" rel="noopener noreferrer" className="text-white">www.Kruwirat.com</a>
          </small>
        </div>
      </div>
    </div>
  );
}

export default Login;